import { useState, useEffect, useRef } from 'react';
import { ActionButton } from '../../common/Buttons/Buttons';
import { Header } from '../../common/Header/Header.jsx';
import { SelectPerPage } from '../../common/Forms/Input/Input';
import {
  SalesMembershipTable,
  PendinForApprovalTable,
  LostTable,
} from '../../common/Tables/Tables';
import {
  salesMembershipTableHeader,
  pendingForApprovalTableHeader,
  lostTableHeader,
} from '../../../assets/helpers/tables';
import { notify } from '../../../assets/helpers/toast';
import { salesRoles } from '../../../assets/helpers/roles.js';
import { membershipService } from '../../../services/membershipService';
import { useParams, useHistory } from 'react-router-dom';
import {
  FilterDatePicker,
  Select,
  SearchInput,
} from '../../common/Forms/Input/Input';
import moment from 'moment';
import {
  capitalize,
  renameMembreshipCrossStatus,
  convertToHyphenatedLowerCase,
} from '../../../assets/helpers/funciones';
import { ExportableOtpModules } from '../../../assets/helpers/options.js';

import './AffiliationsDB.scss';
import authService from '../../../services/authService.js';
import { OtpModal } from '../../common/Modals/Modals.jsx';

const itemsPerpage = [10, 25, 50, 100, 500];
export const AffiliationsDB = () => {
  const tableRef = useRef(null);
  const history = useHistory();
  const currentUser = authService?.getUser();
  const isExternalCounter =
    currentUser?.roles?.[0]?.code === salesRoles?.SALES_COUNTER &&
    currentUser?.type === 'Externo';
  // The backend already returns the sales of the whole agency for a master;
  // the front only adds the advisor filter
  const isAgencyMaster = authService?.isAgencyMaster();

  const [isLoading, setIsLoading] = useState(false);

  const { statusId, statusName } = useParams();

  const [otpCode, setOtpCode] = useState('');
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [isLoadingEmail, setIsLoadingEmail] = useState(false);
  const [statusOptions, setStatusOptions] = useState([]);
  const [statusSelected, setStatusSelected] = useState('');
  const [docsConfirmed, setDocsConfirmed] = useState([]);
  const [paymentConfirmed, setPaymentConfirmed] = useState([]);
  const [channels, setChannels] = useState([]);
  const [citiesOptions, setCitiesOptions] = useState([]);
  const [cities, setCities] = useState([]);
  const [channelOptions, setChannelOptions] = useState([]);
  const [advisorOptions, setAdvisorOptions] = useState([]);
  const [advisors, setAdvisors] = useState([]);
  // const [vehicleModelOptions, setVehicleModelOptions] = useState([]);
  const [vehicleModels, setVehicleModels] = useState([]);
  // const [vehicleBrand, setVehicleBrand] = useState([]);
  // const [vehicleBrandOptions, setVehicleBrandOptions] = useState([]);
  // const [statesOptions, setStatesOptions] = useState([]);
  const [state, setState] = useState([]);

  const [pendingPaymentHeader, setPendingPaymentHeader] = useState(
    pendingForApprovalTableHeader
  );
  const [affiliationHeader, setAffiliationHeader] = useState(
    salesMembershipTableHeader
  );

  const approvedOptions = {
    'SI': 'true',
    'NO': 'false',
  };

  const [membershipsDatatable, setMembershipsDatatable] = useState({
    limit: itemsPerpage[2],
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    dateFrom: '',
    dateTo: '',
    isLoading: false,
    searchParam: '',
  });

  const setFirstPage = () => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
      };
    });
  };

  const handleSinceDateChange = (e) => {
    if (e > dateTo && dateTo) {
      notify('Ingrese una fecha en un rago valido ', 'info');
    } else {
      setFirstPage();
      setDateFrom(e);
    }
  };

  const handleUntilDateChange = (e) => {
    if (e < dateFrom && dateFrom) {
      notify('Ingrese una fecha en un rago valido ', 'info');
    } else {
      setFirstPage();
      setDateTo(e);
    }
  };

  const formatSellers = (arr) => {
    let data = [];
    for (let i = 0; i < arr?.length; i++) {
      data.push({
        name: `${arr[i]?.firstName} ${arr[i]?.lastName}`,
        _id: arr[i]?._id,
      });
    }
    data = data
      .filter(
        (item, index, self) =>
          self.findIndex((t) => t._id === item._id) === index
      )
      .sort((a, b) => a.name.localeCompare(b.name));
    return data;
  };

  const selectitemsPerpage = (event) => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        limit: parseInt(event.target.value),
      };
    });
  };

  const handlePageChange = (event, value) => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * membershipsDatatable?.limit,
      };
    });
  };

  const handleSearchChange = (event) => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        searchParam: event?.target?.value,
        page: 1,
        offset: 0,
        data: false,
      };
    });
  };

  const redirectToEditOrder = (orderId) => {
    history.push(`/afiliations/edit-order/${orderId}`);
  };

  const redirectToOrderDetail = (order) => {
    history.push(
      `/afiliations/order-details/${order?._id}/vehicle/${order?.vehicleId}`
    );
  };

  const renewMembership = (membership) => {
    if (!isLoading) {
      setIsLoading(true);
      membershipService
        .reativateMembership(membership?._id)
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            setIsLoading(false);
            notify(`Membresia reactivada`, 'success');
            redirectToEditOrder(membership?._id);
          } else {
            setIsLoading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch(() => { });
    }
  };

  const handlePaymentConfirmedFilter = (array) => {
    setPaymentConfirmed(array);
  };

  const handleDocsConfirmedFilter = (array) => {
    setDocsConfirmed(array);
  };

  const approvedOptionsList = (obj) => {
    let options = [];
    for (let item in obj) {
      options.push({
        //set _id as the item value and name as the key value
        _id: obj[item],
        name: item,
      });
    }
    return options;
  };

  const channelListOptions = (arr) => {
    let channels = [];
    arr?.sort((a, b) => {
      if (a?.channel < b?.channel) {
        return -1;
      }
      if (a?.channel > b?.channel) {
        return 1;
      }
      return 0;
    });

    if (arr) {
      for (let i = 0; i < arr?.length; i++) {
        channels.push({
          _id: arr[i]?._id,
          name: capitalize(arr[i]?.shortName),
        });
      }
    }
    return channels;
  };

  const handleChannelOptions = (arr) => {
    setChannelOptions(arr);
  };

  const handleVehicleBrand = (str) => {
    // setVehicleBrand(str);
    setVehicleModels([]);
    // setVehicleModelOptions([]);
  };

  const handleStates = (str) => {
    setState(str);
    setCities([]);
    setCitiesOptions([]);
  };

  const citiesOptionsList = (arr) => {
    let cities = [];
    arr?.sort((a, b) => {
      if (a?.name < b?.name) {
        return -1;
      }
      if (a?.name > b?.name) {
        return 1;
      }
      return 0;
    });

    if (arr) {
      for (let i = 0; i < arr?.length; i++) {
        cities.push({
          _id: arr[i]?._id,
          name: capitalize(arr[i]?.name),
        });
      }
    }
    return cities;
  };

  const handleCities = (arr) => {
    setCities(arr);
  };

  const vehicleModelsOptionsList = (arr) => {
    let vehicleModels = [];
    arr?.sort((a, b) => {
      if (a?.name < b?.name) {
        return -1;
      }
      if (a?.name > b?.name) {
        return 1;
      }
      return 0;
    });

    if (arr) {
      for (let i = 0; i < arr?.length; i++) {
        vehicleModels.push({
          _id: arr[i]?._id,
          name: capitalize(arr[i]?.model),
        });
      }
    }

    return vehicleModels;
  };

  const statesOptionsList = (arr) => {
    let states = [];
    arr?.sort((a, b) => {
      if (a?.name < b?.name) {
        return -1;
      }
      if (a?.name > b?.name) {
        return 1;
      }
      return 0;
    });

    if (arr) {
      for (let i = 0; i < arr?.length; i++) {
        states.push({
          _id: arr[i]?._id,
          name: capitalize(arr[i]?.name),
        });
      }
    }
    return states;
  };

  const vehicleBrandOptionsList = (arr) => {
    let vehicleBrands = [];
    arr?.sort((a, b) => {
      if (a?.name < b?.name) {
        return -1;
      }
      if (a?.name > b?.name) {
        return 1;
      }
      return 0;
    });

    if (arr) {
      for (let i = 0; i < arr?.length; i++) {
        vehicleBrands.push({
          _id: arr[i]?._id,
          name: capitalize(arr[i]?.brand),
        });
      }
    }
    return vehicleBrands;
  };

  const handleVehicleModels = (arr) => {
    setVehicleModels(arr);
  };

  const handleAdvisorOptions = (arr) => {
    setAdvisorOptions(arr);
  };

  const clearFilters = () => {
    setDocsConfirmed([]);
    setPaymentConfirmed([]);
    setChannelOptions([]);
    setAdvisorOptions([]);
    setCities([]);
    setVehicleModels([]);
    // setVehicleBrand([]);
    setState([]);

    // Limpiar también las opciones dependientes
    setCitiesOptions([]);
    // setVehicleModelOptions([]);
  };

  useEffect(() => {
    getStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getMemberships();
    // getMembershipsByStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    membershipsDatatable?.page,
    membershipsDatatable?.offset,
    membershipsDatatable?.limit,
    membershipsDatatable?.type,
    dateFrom,
    dateTo,
    docsConfirmed,
    paymentConfirmed,
    advisorOptions,
    channelOptions,
    cities,
    vehicleModels,
    statusSelected,
  ]);

  useEffect(() => {
    if (statusSelected) {
      // Limpiar filtros cuando cambies de status
      setDocsConfirmed([]);
      setPaymentConfirmed([]);
      setChannelOptions([]);
      setAdvisorOptions([]);
      setCities([]);
      setVehicleModels([]);
      // setVehicleBrand([]);
      setState([]);

      // Resetear paginación
      setMembershipsDatatable((prevState) => ({
        ...prevState,
        page: 1,
        offset: 0,
      }));
    }
  }, [statusSelected]);

  const validateIdLogic = () => {
    let response = '';
    if (['all', 'todos'].includes(statusName)) {
      response = '';
    }
    if (statusId && statusId !== 'none') {
      return (response = statusId);
    }
    return response;
  };

  // const getMembershipsByStatus = () => {
  //   let pedingForApproval = false;
  //   if (window.location.pathname.includes('pendiente-de-aprobacion')) {
  //     pedingForApproval = true;
  //   }

  //   if (
  //     membershipsDatatable?.searchParam ||
  //     pedingForApproval ||
  //     dateFrom ||
  //     dateTo
  //   ) {
  //     setMembershipsDatatable((prevState) => {
  //       return {
  //         ...prevState,
  //         isLoading: true,
  //       };
  //     });

  //     let body = {};

  //     let params = {
  //       status: validateIdLogic(),
  //       dateFrom: dateFrom ? moment(dateFrom).format('MM-DD-YYYY') : '',
  //       dateTo: dateTo ? moment(dateTo).format('MM-DD-YYYY') : '',
  //       limit: membershipsDatatable?.limit,
  //       offset: membershipsDatatable?.offset,
  //       searchParam: membershipsDatatable?.searchParam,
  //     };

  //     if (window.location.pathname.includes('pendiente-de-aprobacion')) {
  //       if (docsConfirmed.length === 1) {
  //         params.verifiedDocuments = docsConfirmed[0];
  //       }

  //       if (paymentConfirmed.length === 1) {
  //         params.verifiedPayment = paymentConfirmed[0];
  //       }

  //       if (channelOptions.length > 0) {
  //         body.channels = channelOptions;
  //       }

  //       if (advisorOptions.length > 0) {
  //         body.sellers = advisorOptions;
  //       }
  //     }

  //     if (
  //       !window.location.pathname.includes('vencido') &&
  //       !window.location.pathname.includes('pendiente-de-aprobacion')
  //     ) {
  //       if (channelOptions.length > 0) {
  //         body.channels = channelOptions;
  //       }
  //       if (cities.length > 0) {
  //         body.cities = cities;
  //       }

  //       if (vehicleModels.length > 0) {
  //         body.models = vehicleModels;
  //       }
  //     }

  //     setIsLoading(true);

  //     membershipService
  //       .getMembershipsCountByCondition(filterParams(params), body)
  //       .then((response) => {
  //         if (response.status === 200) {
  //           setMembershipsDatatable((prevState) => {
  //             return {
  //               ...prevState,
  //               count: response?.data?.total,
  //             };
  //           });
  //           setIsLoading(false);
  //         } else {
  //           notify(`${response.message}` || 'error', 'error');
  //           setIsLoading(false);
  //         }
  //       })
  //       .catch(() => {
  //         setIsLoading(false);
  //       });

  //     membershipService
  //       .getMembershipsForApproval(filterParams(params), body)
  //       .then((response) => {
  //         if (response.status === 200) {
  //           setMembershipsDatatable((prevState) => {
  //             setIsLoading(false);
  //             return {
  //               ...prevState,
  //               data: response?.data?.memberships,
  //               isLoading: false,
  //             };
  //           });
  //         } else {
  //           notify(`${response.message}` || 'error', 'error');
  //           setMembershipsDatatable((prevState) => {
  //             return {
  //               ...prevState,
  //               isLoading: false,
  //             };
  //           });
  //           setIsLoading(false);
  //         }
  //       })
  //       .catch(() => {
  //         setIsLoading(false);
  //       });

  //     return true;
  //   }
  // };

  const getMemberships = () => {
    let params = {};
    let body = {
      limit: membershipsDatatable?.limit,
      offset: membershipsDatatable?.offset,
      status: validateIdLogic(),
      dateFrom: dateFrom
        ? moment(dateFrom).format('YYYY-MM-DD')
        : window.location.pathname.includes('pendiente-de-aprobacion')
          ? moment().subtract(3, 'months').format('YYYY-MM-DD')
          : moment().add(1, 'day').format('YYYY-MM-DD'),
      dateTo: dateTo
        ? moment(dateTo).format('YYYY-MM-DD')
        : window.location.pathname.includes('pendiente-de-aprobacion')
          ? moment().format('YYYY-MM-DD')
          : moment().add(2, 'days').format('YYYY-MM-DD'),
    };

    if (body.status === '') {
      delete body.status;
    }

    if (membershipsDatatable?.searchParam) {
      body.searchParam = membershipsDatatable?.searchParam;
    }

    if (window.location.pathname.includes('pendiente-de-aprobacion')) {
      if (docsConfirmed.length === 1) {
        body.verifiedDocuments = docsConfirmed[0];
      }
      if (paymentConfirmed.length === 1) {
        body.verifiedPayment = paymentConfirmed[0];
      }
      if (channelOptions.length > 0) {
        body.channels = channelOptions;
      }
      if (advisorOptions.length > 0) {
        body.sellers = advisorOptions;
      }
    }

    if (
      !window.location.pathname.includes('vencido') &&
      !window.location.pathname.includes('pendiente-de-aprobacion')
    ) {
      if (channelOptions.length > 0) {
        body.channels = channelOptions;
      }
      if (cities.length > 0) {
        body.cities = cities;
      }
      if (vehicleModels.length > 0) {
        body.models = vehicleModels;
      }
      if (state.length > 0) {
        body.states = state;
      }
      if (isAgencyMaster && advisorOptions.length > 0) {
        body.sellers = advisorOptions;
      }
    }

    setIsLoading(true);

    membershipService
      .getMembershipsByType(params, body)
      .then((response) => {
        if (response.status === 200) {
          // SIEMPRE cargar filterOptions cuando offset es 0 O cuando no hay opciones cargadas
          const shouldLoadFilterOptions =
            membershipsDatatable?.offset === 0 ||
            (channels.length === 0 &&
              advisors.length === 0 &&
              citiesOptions.length === 0);

          if (shouldLoadFilterOptions) {
            const filterOptions = response.data?.filtersOptions?.[0] || {};

            // Actualiza los estados de opciones
            const formattedSellers = formatSellers(filterOptions.sellers || []);
            const formattedCities = citiesOptionsList(
              filterOptions.cities || []
            );
            const formattedModels = vehicleModelsOptionsList(
              filterOptions.models || []
            );
            const formattedStates = statesOptionsList(
              filterOptions.states || []
            );
            const formattedBrands = vehicleBrandOptionsList(
              filterOptions.brands || []
            );
            const formattedChannels = channelListOptions(
              filterOptions.channels || []
            );

            // Actualizar estados
            setAdvisors(formattedSellers);
            setCitiesOptions(formattedCities);
            // setVehicleModelOptions(formattedModels);
            // setStatesOptions(formattedStates);
            // setVehicleBrandOptions(formattedBrands);
            setChannels(formattedChannels);

            // INMEDIATAMENTE después de cargar las opciones, configurar los headers
            const statusName = statusOptions?.find(
              (s) => s._id === statusSelected
            )?.name;

            if (statusName === 'Pendiente De Aprobacion') {
              const newPendingHeader = pendingForApprovalTableHeader.map(
                (header) => {
                  if (header.name === 'Documentos comprobados') {
                    return {
                      ...header,
                      filterOptions: approvedOptionsList(approvedOptions),
                      filterSearch: handleDocsConfirmedFilter,
                      sortable: true,
                    };
                  }
                  if (header.name === 'Pago comprobado') {
                    return {
                      ...header,
                      filterOptions: approvedOptionsList(approvedOptions),
                      filterSearch: handlePaymentConfirmedFilter,
                      sortable: true,
                    };
                  }
                  if (header.name === 'Canal') {
                    return {
                      ...header,
                      filterOptions: formattedChannels,
                      filterSearch: handleChannelOptions,
                      sortable: true,
                    };
                  }
                  if (header.name === 'Asesor') {
                    return {
                      ...header,
                      filterOptions: formattedSellers,
                      filterSearch: handleAdvisorOptions,
                      sortable: true,
                    };
                  }
                  return header;
                }
              );
              setPendingPaymentHeader(newPendingHeader);
            } else if (statusName === 'Documentación Pendiente') {
              const newPendingHeader = pendingForApprovalTableHeader
                .filter((header) => header.name !== 'Documentos comprobados')
                .map((header) => {
                  if (header.name === 'Pago comprobado') {
                    return {
                      ...header,
                      filterOptions: approvedOptionsList(approvedOptions),
                      filterSearch: handlePaymentConfirmedFilter,
                      sortable: true,
                    };
                  }
                  if (header.name === 'Canal') {
                    return {
                      ...header,
                      filterOptions: formattedChannels,
                      filterSearch: handleChannelOptions,
                      sortable: true,
                    };
                  }
                  if (header.name === 'Asesor') {
                    return {
                      ...header,
                      filterOptions: formattedSellers,
                      filterSearch: handleAdvisorOptions,
                      sortable: true,
                    };
                  }
                  return header;
                });
              setPendingPaymentHeader(newPendingHeader);
            } else {
              const newAffiliationHeader = salesMembershipTableHeader(
                response.data?.maxPayCount || 6
              ).map((header) => {
                if (isAgencyMaster && header.name === 'Asesor responsable') {
                  return {
                    ...header,
                    filterOptions: formattedSellers,
                    filterSearch: handleAdvisorOptions,
                    sortable: true,
                  };
                }
                if (header.name === 'Ciudad') {
                  return {
                    ...header,
                    filterOptions: formattedCities,
                    filterSearch: handleCities,
                    sortable: true,
                  };
                }
                if (header.name === 'Modelo') {
                  return {
                    ...header,
                    filterOptions: formattedModels,
                    filterSearch: handleVehicleModels,
                    sortable: true,
                  };
                }
                if (header.name === 'Canal') {
                  return {
                    ...header,
                    filterOptions: formattedChannels,
                    filterSearch: handleChannelOptions,
                    sortable: true,
                  };
                }
                if (header.name === 'Estado') {
                  return {
                    ...header,
                    filterOptions: formattedStates,
                    filterSearch: handleStates,
                    sortable: true,
                  };
                }
                if (header.name === 'Marca') {
                  return {
                    ...header,
                    filterOptions: formattedBrands,
                    filterSearch: handleVehicleBrand,
                    sortable: true,
                  };
                }
                return header;
              });
              setAffiliationHeader(newAffiliationHeader);
            }
          }
          setMembershipsDatatable((prevState) => {
            setIsLoading(false);
            return {
              ...prevState,
              data: response?.data?.memberships,
              paymentsQty: response?.data?.maxPayCount || 0,
              count: response?.data?.total,
              isLoading: false,
            };
          });
        } else {
          notify(`${response.message}` || 'error', 'error');
          setMembershipsDatatable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
          setIsLoading(false);
        }
      })
      .catch(() => {
        setIsLoading(false);
      });

    return true;
  };

  const showOtp = () => {
    if (!otpCode && !isLoading) {
      authService
        .sendOtp({ module: ExportableOtpModules.MEMBERSHIP_EXPORTABLE })
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            notify('Ingrese el código OTP enviado a su correo', 'Success');
            setShowOtpModal(true);
          } else {
            notify(`${response.message}`, 'error');
          }
        })
        .catch((error) => {
        });
    }
  };

  const exportAffiliationTable = async () => {
    let params = {};
    let body = {
      limit: membershipsDatatable?.limit,
      offset: membershipsDatatable?.offset,
      status: validateIdLogic(),
      dateFrom: dateFrom
        ? moment(dateFrom).format('MM-DD-YYYY')
        : moment().subtract(1, 'month').format('MM-DD-YYYY'),
      dateTo: dateTo
        ? moment(dateTo).format('MM-DD-YYYY')
        : moment().format('MM-DD-YYYY'),
      byMail: true,
    };

    if (body.status === '') {
      delete body.status;
    }

    if (membershipsDatatable?.searchParam) {
      body.searchParam = membershipsDatatable?.searchParam;
    }

    if (window.location.pathname.includes('pendiente-de-aprobacion')) {
      if (docsConfirmed.length === 1) {
        body.verifiedDocuments = docsConfirmed[0];
      }
      if (paymentConfirmed.length === 1) {
        body.verifiedPayment = paymentConfirmed[0];
      }
      if (channelOptions.length > 0) {
        body.channels = channelOptions;
      }
      if (advisorOptions.length > 0) {
        body.sellers = advisorOptions;
      }
    }

    if (
      !window.location.pathname.includes('vencido') &&
      !window.location.pathname.includes('pendiente-de-aprobacion')
    ) {
      if (channelOptions.length > 0) {
        body.channels = channelOptions;
      }
      if (cities.length > 0) {
        body.cities = cities;
      }
      if (vehicleModels.length > 0) {
        body.models = vehicleModels;
      }
      if (state.length > 0) {
        body.states = state;
      }
      if (isAgencyMaster && advisorOptions.length > 0) {
        body.sellers = advisorOptions;
      }
    }

    if (
      ![
        salesRoles?.SALES_ADMIN,
        salesRoles?.SALES_ADMIN_AUX,
        salesRoles?.SALES_DEVELOPER,
        salesRoles?.SALES_SUPERVISOR,
      ].includes(authService?.getUserType()) &&
      body.byMail === true
    ) {
      body.otp = otpCode;
    }

    if (!isLoadingEmail) {
      notify(
        `Solicitud de exportable realizada, espere a recibir un correo con el archivo correspondiente`,
        'info'
      );

      membershipService
        .getMembershipsByType(params, body)
        .then((response) => {
          if (response.status === 200) {
            setIsLoadingEmail(false);
            setOtpCode('');
            setShowOtpModal(false);
          } else {
            notify(`${response.message}` || 'error', 'error');
            setIsLoadingEmail(false);
          }
        })
        .catch((error) => {
          setIsLoadingEmail(false);
        });
      return true;
    }
  };

  const redirectToOtherStatus = (e) => {
    const { value } = e?.target;

    if (value === 'all') {
      setStatusSelected('all');
      history.push(`/afiliations/status/all/none`);
      // NO usar window.location.reload() - esto reinicia todo el componente
    } else {
      let [selected] = statusOptions?.filter((s) => s?._id === value);
      setStatusSelected(selected?._id); // Actualizar el estado inmediatamente
      history.push(
        `/afiliations/status/${convertToHyphenatedLowerCase(
          renameMembreshipCrossStatus(selected?.name)
        )}/${selected?._id}`
      );
      // NO usar window.location.reload() - esto reinicia todo el componente
    }
    setMembershipsDatatable((prevState) => ({
      ...prevState,
      page: 1,
      offset: 0,
    }));
  };

  const getStatus = () => {
    membershipService
      .getStatuses()
      .then((response) => {
        if (response.status === 200) {
          let data = [];
          data.push({
            _id: 'all',
            name: 'Todos',
          });

          let selectedStatusFound = false;

          for (let i = 0; i < response?.data.length; i++) {
            if (response?.data[i]?.name !== 'DENEGADO') {
              data.push({
                _id: response?.data[i]?._id,
                name: capitalize(response?.data[i]?.name),
              });
            }

            if (response?.data[i]?._id === statusId) {
              setStatusSelected(response?.data[i]?._id);
              selectedStatusFound = true;
            }
          }

          // Si no se encontró el statusId en los params, usar 'all' por defecto
          if (!selectedStatusFound) {
            setStatusSelected('all');
          }

          setStatusOptions(data);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
    return true;
  };

  const statusAndCount = (statusOptions) => {
    let name = statusOptions?.filter((s) => s?._id === statusSelected)[0]?.name;
    if (name) {
      name = ' (' + name + ') ';
    } else {
      name = ' ';
    }

    return (
      <span>
        :{name} {'   '} {membershipsDatatable?.count}{' '}
      </span>
    );
  };

  const selectedStatusName = statusOptions?.find(
    (s) => s?._id === statusSelected
  )?.name;

  return (
    <>
      <Header />
      {/* <LoadSpinner show={isLoading} /> */}
      {showOtpModal && (
        <OtpModal
          show={showOtpModal}
          handleClose={() => {
            setShowOtpModal(false);
            setOtpCode('');
          }}
          code={otpCode}
          setCode={setOtpCode}
          handleExport={exportAffiliationTable}
        />
      )}
      <div className="service-with-container container">
        <div className="buttons-container">
          <h1 className="title-component">
            {isAgencyMaster
              ? 'Ventas de mi agencia'
              : isExternalCounter
                ? 'Mis ventas'
                : 'Base de datos de afiliaciones'}
            {statusAndCount(statusOptions)}
          </h1>
          {![
            salesRoles?.SALES_HUNTER,
            salesRoles?.SALES_COUNTER,
            salesRoles?.SALES_ADMIN_AUX,
            salesRoles?.SALES_KEY_ACCOUNTS
          ].includes(authService?.getUserType()) && (
              <ActionButton
                label={'Exportar'}
                action={() => {
                  if (
                    ![
                      salesRoles?.SALES_ADMIN,
                      salesRoles?.SALES_ADMIN_AUX,
                      salesRoles?.SALES_DEVELOPER,
                      salesRoles?.SALES_SUPERVISOR,
                    ].includes(authService?.getUserType())
                  ) {
                    showOtp();
                  } else {
                    exportAffiliationTable();
                  }
                }}
              />
            )}
        </div>
        <div className="breadcrumb-container">
          <div></div>
          <div className="exportables-buttons-container">
            <div style={{ width: '100%' }} className="row">
              <div className="col-12 col-md-2" style={{ marginTop: '30px' }}>
                <SearchInput
                  placeholder={
                    'Nombre o Apellido, Teléfono, Cédula ,Referencia o Placa'
                  }
                  searchAction={getMemberships}
                  value={membershipsDatatable?.searchParam}
                  onChange={handleSearchChange}
                  width="50px"
                />
              </div>
              <div
                style={{ marginTop: '6px', marginLeft: '12px' }}
                className="col-12 col-md-2 col-lg-1"
              >
                <Select
                  options={statusOptions}
                  label={'Tipo'}
                  value={statusSelected}
                  onChange={redirectToOtherStatus}
                />
              </div>
              {![
                // salesRoles?.SALES_HUNTER,
                // salesRoles?.SALES_COUNTER,
                // salesRoles?.SALES_FARMER,
                salesRoles?.SALES_ADMIN_AUX,
              ].includes(authService?.getUserType()) ? (
                <>
                  <FilterDatePicker
                    bootstrap={'col-12 col-md-2'}
                    label={'Desde'}
                    type={'date'}
                    name={'dateFrom'}
                    placeholder={''}
                    onChange={handleSinceDateChange}
                    value={dateFrom}
                    disabled={membershipsDatatable?.isLoading}
                  />
                  <FilterDatePicker
                    bootstrap={'col-12 col-md-2'}
                    label={'Hasta'}
                    type={'date'}
                    name={'dateTo'}
                    placeholder={''}
                    onChange={handleUntilDateChange}
                    value={dateTo}
                    disabled={membershipsDatatable?.isLoading}
                  />
                </>
              ) : null}
              <div
                style={{
                  marginTop: '24px',
                  marginLeft: 'auto',
                  width: '450px',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  textAlign: 'center',
                  alignItems: 'center',
                }}
              >
                {![
                  salesRoles?.SALES_FARMER,
                  salesRoles?.SALES_HUNTER,
                  salesRoles?.SALES_COUNTER,
                  salesRoles?.SALES_ADMIN_AUX,
                  salesRoles?.SALES_KEY_ACCOUNTS
                ].includes(authService?.getUserType()) && (
                    <SelectPerPage
                      label={'Registros por página'}
                      options={itemsPerpage}
                      value={membershipsDatatable?.limit}
                      onChange={selectitemsPerpage}
                    />
                  )}
                {!['Vencido', 'Pendiente De Aprobacion'].includes(
                  statusOptions?.filter((s) => s?._id === statusSelected)[0]
                    ?.name
                ) && (
                    <ActionButton
                      label={'Limpiar filtros'}
                      action={() => clearFilters()}
                    />
                  )}
              </div>
            </div>
          </div>
        </div>

        {['Pendiente De Aprobacion', 'Documentación Pendiente'].includes(
          selectedStatusName
        ) && (
            <PendinForApprovalTable
              header={pendingPaymentHeader}
              data={membershipsDatatable}
              handlePageChange={handlePageChange}
              redirectToEditOrder={redirectToEditOrder}
              redirectToOrderDetail={redirectToOrderDetail}
              renewMembership={renewMembership}
              tableRef={tableRef}
              dateFrom={dateFrom}
              dateTo={dateTo}
            />
          )}
        {selectedStatusName === 'Vencido' && (
            <LostTable
              header={lostTableHeader}
              data={membershipsDatatable}
              handlePageChange={handlePageChange}
              redirectToEditOrder={redirectToEditOrder}
              redirectToOrderDetail={redirectToOrderDetail}
              renewMembership={renewMembership}
              tableRef={tableRef}
              dateFrom={dateFrom}
              dateTo={dateTo}
            />
          )}
        {!['Pendiente De Aprobacion', 'Vencido', 'Documentación Pendiente'].includes(
          selectedStatusName
        ) && (
            <SalesMembershipTable
              header={affiliationHeader}
              data={membershipsDatatable}
              handlePageChange={handlePageChange}
              redirectToEditOrder={redirectToEditOrder}
              redirectToOrderDetail={redirectToOrderDetail}
              renewMembership={renewMembership}
              tableRef={tableRef}
              dateFrom={dateFrom}
              dateTo={dateTo}
            />
          )}
      </div>
    </>
  );
};
